import { IPromise, IScope } from "angular";
import { IStateInit } from "@gtmhub/core/routing";
import { IIndicator } from "@gtmhub/error-handling";
import { IAsigneeIdsGoalsMap } from "@gtmhub/goals/models";
import { GoalService } from "@gtmhub/goals/services/goal.service";
import { ICollectionMap } from "@webapp/core/core.models";

interface IInspectAssigneesWorkflowService {
  assigneesStatName: string;
  planningSessionId: string;
  page: number;
}

interface IInspectAssigneesWorkflowCtrlScope extends IScope {
  indicators: {
    loading?: IIndicator;
    paging?: IIndicator;
  };
  params: IInspectAssigneesWorkflowService;
  assigneesGoalsMap: ICollectionMap<IAsigneeIdsGoalsMap>;
  currentPage: number;
  totalPages: number;
  itemsPerPage: number;
  onPageChange(page: number): void;
}

const itemsPerPage = 10;

export class InspectAssigneesWorkflowCtrl implements IStateInit {
  public static $inject = ["$scope", "$stateParams", "GoalService", "AssigneeActions", "$ngRedux"];

  constructor(private $scope: IInspectAssigneesWorkflowCtrlScope, private $stateParams: IInspectAssigneesWorkflowService, private goalService: GoalService) {
    this.init();
  }

  public stateInit(): IPromise<unknown> {
    return this.init();
  }

  private strings = {
    loading: "loading",
    paging: "paging",
    pendingReviewsDashed: "pending-reviews",
    draftOwnersDashed: "draft-owners",
  };

  private getDataParams: { approvalStatus: { draft: string; pending: string }; review: string } = {
    approvalStatus: {
      draft: "draft",
      pending: "pending",
    },
    review: "pending",
  };

  private init = (): IPromise<unknown> => {
    this.$scope.indicators = {
      loading: { progress: true },
    };

    this.$scope.currentPage = 1;
    this.$scope.itemsPerPage = itemsPerPage;
    this.$scope.onPageChange = this.onPageChange;

    this.$scope.params = { ...this.$stateParams };

    return this.configureGetDataPromise(this.$stateParams.assigneesStatName, 0).then(
      (assigneesGoalsMap) => {
        delete this.$scope.indicators.loading;

        this.$scope.assigneesGoalsMap = assigneesGoalsMap;

        this.$scope.totalPages = Math.ceil(this.$scope.assigneesGoalsMap.totalCount / itemsPerPage);
      },
      (error) => (this.$scope.indicators.loading = { error })
    );
  };

  private configureGetDataPromise = (statName: string, skip: number): IPromise<ICollectionMap<IAsigneeIdsGoalsMap>> => {
    switch (statName) {
      case this.strings.pendingReviewsDashed:
        return this.goalService.getGoalsGroupedByReviewers(
          this.$stateParams.planningSessionId,
          skip,
          itemsPerPage,
          this.getDataParams.review,
          this.getDataParams.approvalStatus.pending
        );

      case this.strings.draftOwnersDashed:
        return this.goalService.getGoalsGroupedByOwners(this.$stateParams.planningSessionId, skip, itemsPerPage, this.getDataParams.approvalStatus.draft);

      default:
        break;
    }
  };

  private onPageChange = (page: number): void => {
    this.$scope.currentPage = page;

    const skip = (page - 1) * itemsPerPage;
    this.onPageChanged(skip);
  };

  private onPageChanged = (skip: number): void => {
    this.$scope.indicators.paging = { progress: true };

    this.configureGetDataPromise(this.$stateParams.assigneesStatName, skip).then(
      (assigneesGoalsMap) => {
        delete this.$scope.indicators.paging;

        this.$scope.assigneesGoalsMap = assigneesGoalsMap;
        this.$scope.totalPages = Math.ceil(this.$scope.assigneesGoalsMap.totalCount / itemsPerPage);
      },
      (error) => (this.$scope.indicators.paging = { error })
    );
  };
}
